/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AxiosResponse } from "axios";
import { call, put, takeLatest } from "redux-saga/effects";
import api from "_config/api";

export type Manifestacao = {
  id: string;
  titulo: string;
  descricao: string;
  numero: number;
  name: string;
};

interface State {
  isRequesting: boolean;
  successPayload: GeoJSON.FeatureCollection<GeoJSON.Point, Manifestacao> | null;
  errors: string[];
}

const initialState: State = {
  isRequesting: false,
  successPayload: null,
  errors: []
};

const getManifestacoesGeojsonSlice = createSlice({
  name: "ouvidoria.manifestacao@getManifestacoesGeojson",
  initialState,
  reducers: {
    getManifestacoesGeojsonRequest: (state): void => {
      state.isRequesting = true;
      state.errors = [];
    },
    getManifestacoesGeojsonSuccess: (
      state,
      action: PayloadAction<
        GeoJSON.FeatureCollection<GeoJSON.Point, Manifestacao>
      >
    ): void => {
      state.isRequesting = false;
      state.successPayload = action.payload;
    },
    getManifestacoesGeojsonFailed: (
      state,
      action: PayloadAction<string[]>
    ): void => {
      state.isRequesting = false;
      state.errors = action.payload;
    }
  }
});

function* sagaFunction(params: { type: string }) {
  try {
    const response: AxiosResponse<any> = yield call(
      api.get,
      `api/v1/cidadao/ouvidoria/manifestacoes/geojson/user`
    );

    yield put(getManifestacoesGeojsonSuccess(response.data));
  } catch (error) {
    yield put(getManifestacoesGeojsonFailed([]));
  }
}

export const {
  getManifestacoesGeojsonFailed,
  getManifestacoesGeojsonRequest,
  getManifestacoesGeojsonSuccess
} = getManifestacoesGeojsonSlice.actions;

export const { reducer } = getManifestacoesGeojsonSlice;
export const saga = takeLatest(
  getManifestacoesGeojsonRequest.type,
  sagaFunction
);

export default getManifestacoesGeojsonSlice.reducer;
